import React from 'react';
import './styles/PaymentPlanSchedules.scss';
import { Control, actions as formActions } from 'react-redux-form';
import { ensureKeyed } from 'utils';
import PropTypes from 'prop-types';
import ControlGroup from '../../forms/ControlGroup';
import ScheduleItemRenderer from './ScheduleItem';
import { SchoolYearType } from '../../../propTypes';

// Used to edit month, year, percent arrangements for payment plan schedules/installments
const ScheduleEditor = (
  {
    databaseScheduleItems,
    formDuck,
    itemsName,
    formNumOfPayments,
    formScheduleItems,
    schoolYear,
    defaultNumPayments,
    dispatch,
    numPastInstallments
  }
) => {
  const setNumberOfItems = (e) => {
    // remove schedule items past the current number of payments
    const itemNumber = parseInt(e.target.value, 10) - 1;
    for (let i = formScheduleItems.length; i >= 0; i -= 1) {
      if (i > itemNumber) {
        dispatch(formActions.remove(`${formDuck.model}.${itemsName}`, i));
      }
    }
  };

  const numOfPayments = formNumOfPayments ? parseInt(formNumOfPayments, 10) : defaultNumPayments;
  const numEditable = numPastInstallments > 0 ? (numOfPayments - numPastInstallments) : numOfPayments;
  let lockedPercent = 0;
  for (let i = 0; i < numPastInstallments; i += 1) {
    lockedPercent += Number(formScheduleItems[i].percent);
  }
  const overallPercent = 100.00 - lockedPercent;

  let numPaymentsOptions = Array.from(Array(12).keys());
  if (numPastInstallments > 0) {
    if (numEditable === 0) {
      numPaymentsOptions = [numOfPayments - 1];
    } else {
      numPaymentsOptions = numPaymentsOptions.slice(numPastInstallments);
    }
  }

  return (
    <React.Fragment>
      <ControlGroup label='Number Of Payments'>
        <Control.select
          model='.number_of_payments'
          defaultValue={numOfPayments}
          className='form-select form-select-sm'
          onChange={setNumberOfItems}
        >
          {(numPaymentsOptions).map(number => <option value={number + 1}>{number + 1}</option>).map(ensureKeyed())}
        </Control.select>
      </ControlGroup>
      <div className='payment-plan-schedule-items'>
        <h3>Schedule</h3>
        {Array.from(Array(numOfPayments).keys()).map(paymentNumber => (
          <div>
            {
              <ScheduleItemRenderer
                paymentNumber={paymentNumber}
                formNumOfPayments={formNumOfPayments}
                formScheduleItems={formScheduleItems}
                databaseScheduleItems={databaseScheduleItems}
                schoolYear={schoolYear}
                numOfPayments={numOfPayments}
                numEditable={numEditable}
                overallPercent={overallPercent}
                itemsName={itemsName}
              />
            }
          </div>
        )).map(ensureKeyed())}
      </div>
    </React.Fragment>
  );
};
ScheduleEditor.propTypes = {
  databaseScheduleItems: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number,
    percent: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  })).isRequired,
  formDuck: PropTypes.shape({
    model: PropTypes.string
  }).isRequired,
  itemsName: PropTypes.string.isRequired,
  formNumOfPayments: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  formScheduleItems: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number,
    percent: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  })).isRequired,
  schoolYear: SchoolYearType.isRequired,
  defaultNumPayments: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  numPastInstallments: PropTypes.number.isRequired
};

export default ScheduleEditor;
